import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { SharedAnonymousModule } from './shared.anonymous.module';
import { TrimPipe } from './trim.pipe';
import { EupDatePipe } from './eupDate.pipe';
import { ReceivedDatePipe } from './receivedDate.pipe';
import { EupDefaultText } from './eupDefaultText.pipe';
import { OrderByPipe } from './orderBy.pipe';
import { SafeHtmlPipe } from './safeHtml.pipe';
import { TableComponent } from './table/table.component';
import { SortableHeaderColumn } from './sortableHeaderColumn/sortableHeaderColumn.component';
import { DownloadLinkModal } from './downloadLinkModal/downloadLinkModal.component';
import { ClickOutsideDirective } from './clickOutside.directive';
import { LabStickyHeaderComponent } from './labStickyHeader/labStickyHeader.component';
import { MobileStickyHeaderComponent } from './stickyHeader/mobile-sticky-header/mobile-sticky-header.component';
import { OrthoCadExportModal } from './orthoCadExport/orthoCadExport.component';
import { RestorativeExportModal } from './restorativeExport/restorativeExport.component';
import { TableFocusElementDirective } from './tableFocusElement.directive';
import { ShowButtonsRowDirective } from './showButtonsRow.directive';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { AccessibilityService } from './accessibility.service';
import { MessagesService } from '../messages/messages.service';
import { DownloadNotificationComponent } from './downloadNotification/downloadNotification.component';
import { ExportDownloadsProgressListComponent } from './exportDownloadsProgressList/exportDownloadsProgressList.component';
import { HighlightTextPipe } from './highlightText.pipe';
import { DieOrdersComponent } from './dieOrders/dieOrders.component';
import { IteroNoteComponent } from './iteroNote/iteroNote.component';
import { IteroOrdersNotesComponent } from './iteroOrdersNotes/iteroOrdersNotes.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { LabExportModal } from './labExport/labExport.component';
import { WindowsAppButtonComponent } from './windowsAppButton/windowsAppButton.component';
import { TimerDirective } from './timer/timer.directive';
import { InactivityTimerDirective } from './inactivity-timer/inactivity-timer.directive';
import { ActivityMonitorDirective } from './inactivity-timer/activity-monitor.directive';
import { FeaturesToggleDirective } from '../featuresToggleSettings/directive/featuresToggle.directive';
import { GenericUIModule } from '@shared/genericUI/module/generic-ui/generic-ui.module';
import { AllowedCaseTypesDirective } from './allowedCaseTypes.directive';
import { AccountManagementService } from '../practiceManagement/services/account-management.service';
import { SafeUrlPipe } from './safeUrl.pipe';
import { ReferralMaskDirective } from './referralMask/referral.mask.directive';
import { TernaryPipe } from './ternary.pipe';
import { MapperPipe } from './mapper.pipe';
import { PrintRxAppComponent } from 'app/rx/print-rx/print-rx-app.component';
import { DateOfBirthPipe } from '@shared/date-of-birth.pipe';
import { CheckOverflowComponent } from '@shared/check-overflow.component';
import { NotificationCardComponent } from 'app/notification-card/notification-card.component';
// eslint-disable-next-line max-len
import { PracticeInformationBlockComponent } from '../practiceManagement/components/info/practice-information-block/practice-information-block.component';
import { SettingsService } from '@shared/settings.service';

const sharedComponents = [
	OrderByPipe,
	TrimPipe,
	TableComponent,
	SortableHeaderColumn,
	DownloadLinkModal,
	LabExportModal,
	EupDatePipe,
	EupDefaultText,
	ReceivedDatePipe,
	TableFocusElementDirective,
	ShowButtonsRowDirective,
	OrthoCadExportModal,
	ClickOutsideDirective,
	LabStickyHeaderComponent,
	MobileStickyHeaderComponent,
	DieOrdersComponent,
	RestorativeExportModal,
	SafeHtmlPipe,
	DownloadNotificationComponent,
	ExportDownloadsProgressListComponent,
	HighlightTextPipe,
	IteroNoteComponent,
	IteroOrdersNotesComponent,
	LabExportModal,
	WindowsAppButtonComponent,
	TimerDirective,
	InactivityTimerDirective,
	ActivityMonitorDirective,
	FeaturesToggleDirective,
	AllowedCaseTypesDirective,
	SafeUrlPipe,
	ReferralMaskDirective,
	TernaryPipe,
	MapperPipe,
	PrintRxAppComponent,
	DateOfBirthPipe,
	PracticeInformationBlockComponent,
	CheckOverflowComponent,
	NotificationCardComponent,
];

@NgModule({
	imports: [SharedAnonymousModule, InfiniteScrollModule, FontAwesomeModule, GenericUIModule],
	declarations: [...sharedComponents],
	exports: [SharedAnonymousModule, GenericUIModule, FontAwesomeModule, ...sharedComponents],
	providers: [
		AccessibilityService,
		MessagesService,
		AccountManagementService,
		EupDatePipe,
		TernaryPipe,
		MapperPipe,
		SettingsService,
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
